export enum TenantApplicationActions {
  EditTenantApplication = 'tenantApplication:EditTenantApplication',
  EditGuarantorInfo = 'tenantApplication:EditGuarantorInfo',
}
